import React from 'react';
import TextField from 'shared/components/text-field/TextField';
import SelectDropdown from 'shared/components/select-dropdown/SelectDropdown';
import {
  workoutsLevels,
  workoutsPhases
} from 'utils/constants/selectFieldsOptions';

class WorkoutCreateForm extends React.Component {
  render() {
    let workoutsLevelsOptions = workoutsLevels.map(level => {
      return { value: level, option: level };
    });
    let { uniquenessError, isSubmitting } = this.props;
    return (
      <div className="create-workout-form">
        <div className="form-content">
          <TextField
            type="text"
            name="name"
            label="Workout Name"
            placeholder="e.g. Wholebody Workout B"
            error={!isSubmitting && uniquenessError ? uniquenessError : false}
          />
          <SelectDropdown name="phase" options={workoutsPhases} label="Phase" />
          <SelectDropdown
            name="level"
            options={workoutsLevelsOptions}
            label="Level"
          />
        </div>
      </div>
    );
  }
}

export default WorkoutCreateForm;
